import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
// import classnames from 'classnames';
// import { message } from 'antd';
// import xss from 'xss';

// import { addComment, getCommentList, getGrade } from '../actions/comment';
// import { byteLength, addClass, changeClass, removeClass } from '../utils/utils';
import styles from './DetailCommentDialog.module.less';
import { logging } from '../actions/log';
import { setDetailCommentVisible } from '../actions/layout';
// import fail from '../static/msg-fail.svg';
import CommentOn from '../components/CommentOn';

const selectAddComment = createSelector(
  state => state.comment,
  comment => comment.addComment,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDetailCommentInfo = createSelector(
  state => state.layout,
  layout => layout.detailCommentInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const addCommentRet = useSelector(selectAddComment);
  const logInfoData = useSelector(selectLogInfo);
  const commentInfo = useSelector(selectDetailCommentInfo);

  // /**
  //  * 产品需要改为点到哪个星星就默认展示哪个星星的内容
  //  */
  // useEffect(() => {
  //   if (
  //     gradeInfo &&
  //     gradeInfo.defaulCommentMap &&
  //     commentInfo &&
  //     commentInfo.handleStar &&
  //     defaulTextArr.length > 0
  //   ) {
  //     handleStar(commentInfo.handleStar, value);
  //   }
  // }, [gradeInfo, commentInfo, defaulTextArr]);

  // /**
  //  * 评论结束处理
  //  */
  // useEffect(() => {
  //   // 评论成功，重新获取当前页面的列表
  //   const bizIdentityStr =
  //     commentInfo.soft.androidType === '1' ? commentInfo.soft.packageName : commentInfo.soft.SoftID;
  //   if (
  //     addCommentRet &&
  //     !addCommentRet.inLoadding &&
  //     addCommentRet.bizIdentity === bizIdentityStr
  //   ) {
  //     if (addCommentRet.status === 0) {
  //       if (commentInfo.time === addCommentRet.time) {
  //         commentInfo.successFunc();
  //       }
  //     }
  //   }
  // }, [addCommentRet, commentInfo]);

  const handleClose = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Grade_Close',
        label: '',
        param2: {
          source: 'Mysofts||Comment',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softId: commentInfo.soft.SoftID,
          softType: commentInfo.soft.androidType ? '1' : '0',
        },
      }),
    );
    dispatch(setDetailCommentVisible({}));
  }, [dispatch]);

  const handleCancel = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'Grade_Cancel',
        label: '',
        param2: {
          source: 'Mysofts||Comment',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softId: commentInfo.soft.SoftID,
          softType: commentInfo.soft.androidType ? '1' : '0',
        },
      }),
    );
    dispatch(setDetailCommentVisible({}));
  });

  const handleUpdate = useCallback(() => {
    commentInfo.successFunc();
    handleCancel();
  }, [commentInfo]);

  return (
    <div className={styles.pop}>
      <div className={styles.detail_comment}>
        <div className="header">
          {/* <span className="title">我的打分</span> */}
          <span className="close iconfont icon-close" onClick={() => handleClose(true)} />
        </div>
        <div>
          <CommentOn
            requestInfo={commentInfo?.requestInfo}
            handleUpdate={handleUpdate}
            scoreNum={commentInfo?.handleStar} //0.5 是因为传0会收起编辑器
            classWrapper="dialogComt"
            commentTargetInfo={commentInfo?.commentTargetInfo}
            title={commentInfo?.soft?.softName}
          />
        </div>
      </div>
    </div>
  );
});
